// import axios from "axios";
import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout, reset } from "../../../features/auth/authSlice";
import tikgImage from "../../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import cancelImage from "../../../images/singleinvoice/cancel.svg";
import { setNotification } from "../../../features/notification/notificationSlice.js";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { useApproveTimeOffRequest, useCancelTimeOffRequest, useRejectTimeOffRequest } from "../../../components/TimeOff/timeOffApi.jsx";

const SUPER_ADMIN = 1;
const ADMIN = 2;
// const USER = 3;
// const PROJECT_MANAGER = 6;
const TEAM_MANAGER = 7;

const ManageTimeOff = ({ user, timeOffData, setTimeOffData, token, isRefetching }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const approveTimeOffRequestMutation = useApproveTimeOffRequest(token);
    const rejectTimeOffRequestMutation = useRejectTimeOffRequest(token);
    const cancelTimeOffRequestMutation = useCancelTimeOffRequest(token);

    const handleApprove = () => {
        setIsApproveModalOpen(true);
    };

    const handleConfirmApprove = async () => {
        try {
            setIsSubmitLoading(true);
            const response = await approveTimeOffRequestMutation.mutateAsync(timeOffData._id);

            if (response.data) {
                toast.success("Time Off request approved successfully!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request Approved successfully!`
                );
                dispatch(setNotification(Date.now()));
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Approved",
                }));
                setIsApproveModalOpen(false);
            }
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "mailfailed") {
                toast.error("TOR approved but something went wrong in sending mail!!", {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request Approved successfully but something went wrong in sending Mail!!!`
                );
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Approved",
                }));
                setIsApproveModalOpen(false);
            } else if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            } else {
                toast.error("Something went wrong in approval!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Something went wrong while Approving Time Off "${timeOffData._id}"!!!`
                );
                console.log(error);
            }
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelApprove = () => {
        setIsApproveModalOpen(false);
    };

    const handleReject = () => {
        setIsRejectModalOpen(true);
    };

    const handleConfirmReject = async () => {
        try {
            setIsSubmitLoading(true);
            await rejectTimeOffRequestMutation.mutateAsync(timeOffData._id);
            toast.success("Time-Off request rejected successfully!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "Time Off",
                `Time Off "${timeOffData._id}" request rejected successfully!`
            );
            dispatch(setNotification(Date.now()));
            setTimeOffData((prevState) => ({
                ...prevState,
                status: "Rejected",
            }));
            setIsRejectModalOpen(false);
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "mailfailed") {
                toast.error("TOR rejected but something went wrong in sending mail!!", {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request rejected successfully but Something went wrong in sending Mail!!!`
                );
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Rejected",
                }));
                setIsRejectModalOpen(false);
            } else if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            } else {
                toast.error("Something went wrong in TOR rejection!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Something went wrong while rejecting Time Off "${timeOffData._id}" request!!!`
                );
                console.log(error);
            }
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelReject = () => {
        setIsRejectModalOpen(false);
    };

    const handleCancel = () => {
        setIsCancelModalOpen(true);
    };

    const handleConfirmCancel = async () => {
        try {
            setIsSubmitLoading(true);
            await cancelTimeOffRequestMutation.mutateAsync(timeOffData._id);
            toast.success("Time-Off request cancelled successfully!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "Time Off",
                `Time Off "${timeOffData._id}" request cancelled successfully!`
            );
            dispatch(setNotification(Date.now()));
            setTimeOffData((prevState) => ({
                ...prevState,
                status: "Cancelled",
            }));
            setIsCancelModalOpen(false);
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "mailfailed") {
                toast.error("TOR cancelled but something went wrong in sending mail!!", {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request cancelled successfully but Something went wrong in sending Mail!!!`
                );
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Cancelled",
                }));
                setIsCancelModalOpen(false);
            } else if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: timeOffData,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            } else {
                toast.error("Something went wrong in TOR cancelation!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Something went wrong while Canceling Time Off "${timeOffData._id}" request!!!`
                );
                console.log(error);
            }
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelCancel = () => {
        setIsCancelModalOpen(false);
    };

    const isAdmin = user && (
        user.userType === SUPER_ADMIN ||
        user.userType === ADMIN ||
        user.userType === TEAM_MANAGER
    );
    const isFutureDate = timeOffData?.start_date &&
        moment.tz(timeOffData.start_date, global.config.getTimeZone()).isAfter(
            moment.tz(global.config.getTimeZone()),
            'day'
        );

    return (
        <>
            <div className="manage-detail-outer">
                <div className="manage-detail-bs2">
                    <div className="invoice-manage-singlepg-head">Manage Time Off</div>
                    <div className="single-invo-sattus">
                        <div className="invo-main-status-head">Request Status</div>
                        <div className="invo-sig-st-btns">
                            <>
                                {isRefetching ? (
                                    <>
                                        {(user &&
                                            (user.userType === SUPER_ADMIN ||
                                                user.userType === ADMIN ||
                                                user.userType === TEAM_MANAGER)) && (
                                            <>
                                                <div
                                                    className="Approve-singlebtn"
                                                    style={{
                                                        backgroundColor: "#e5e7eb",
                                                        borderRadius: "8px",
                                                        animation: "pulse 1.5s ease-in-out infinite",
                                                        cursor: "default",
                                                        pointerEvents: "none",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "80px",
                                                            height: "17px",
                                                            backgroundColor: "#cbd5e1",
                                                            borderRadius: "4px",
                                                            animation: "pulse 1.5s ease-in-out infinite",
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="Reject-singlebtn"
                                                    style={{
                                                        backgroundColor: "#e5e7eb",
                                                        borderRadius: "8px",
                                                        animation: "pulse 1.5s ease-in-out infinite",
                                                        cursor: "default",
                                                        pointerEvents: "none",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "70px",
                                                            height: "17px",
                                                            backgroundColor: "#cbd5e1",
                                                            borderRadius: "4px",
                                                            animation: "pulse 1.5s ease-in-out infinite",
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {(isAdmin || isFutureDate) && (
                                            <div
                                                className="cancel-singlebtn"
                                                style={{
                                                    backgroundColor: "#e5e7eb",
                                                    borderRadius: "8px",
                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                    cursor: "default",
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "70px",
                                                        height: "17px",
                                                        backgroundColor: "#cbd5e1",
                                                        borderRadius: "4px",
                                                        animation: "pulse 1.5s ease-in-out infinite",
                                                    }}
                                                />
                                            </div>
                                        )}
                                        {user && !isAdmin && (
                                            <div
                                                className="Reject-singlebtn"
                                                style={{
                                                    backgroundColor: "#e5e7eb",
                                                    borderRadius: "8px",
                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                    cursor: "default",
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "80px",
                                                        height: "17px",
                                                        backgroundColor: "#cbd5e1",
                                                        borderRadius: "4px",
                                                        animation: "pulse 1.5s ease-in-out infinite",
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    (user &&
                                        (user.userType === SUPER_ADMIN ||
                                            user.userType === ADMIN ||
                                            user.userType === TEAM_MANAGER)) &&
                                    timeOffData?.status !== "Cancelled" && (
                                        <>
                                            {timeOffData?.status === "Approved" ? (
                                                <Link className="Approve-singlebtn approved disable-cursor" >
                                                    Approved <img src={tikgImage} alt="Edit Icon" />
                                                </Link>
                                            ) : (
                                                <Link
                                                    className="Approve-singlebtn"
                                                    onClick={handleApprove}
                                                    disabled={isSubmitLoading}
                                                >
                                                    Approve <img src={tikgImage} alt="Edit Icon" />
                                                </Link>
                                            )}
                                            <Modal
                                                className="delete-modal"
                                                isOpen={isApproveModalOpen}
                                                onRequestClose={
                                                    !isSubmitLoading ? handleCancelApprove : undefined
                                                }
                                                contentLabel="Confirm Approve"
                                                style={{
                                                    content: {
                                                        height: "41%",
                                                        width: "30%",
                                                        position: "fixed",
                                                        top: "50%",
                                                        left: "50%",
                                                        parent: document.querySelector(
                                                            ".admin-outer.time.tracker"
                                                        ),
                                                    },
                                                }}
                                            >
                                                <div className="delete-modal-content">
                                                    <h2>Confirm Approve</h2>
                                                    <p>
                                                        Are you sure you want to Approve this Time Off
                                                        Request?
                                                    </p>
                                                    {isSubmitLoading ? (
                                                        <div className="delete-modal-buttons">
                                                            <div
                                                                style={{
                                                                    width: "100px",
                                                                    height: "40px",
                                                                    backgroundColor: "#e5e7eb",
                                                                    borderRadius: "6px",
                                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                                    marginRight: "10px",
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: "80px",
                                                                    height: "40px",
                                                                    backgroundColor: "#e5e7eb",
                                                                    borderRadius: "6px",
                                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="delete-modal-buttons">
                                                            <button
                                                                className="buttons-approved buttons-approved-new"
                                                                onClick={handleConfirmApprove}
                                                                disabled={isSubmitLoading}
                                                            >
                                                                Approve
                                                            </button>
                                                            <button
                                                                onClick={handleCancelApprove}
                                                                disabled={isSubmitLoading}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Modal>
                                            {timeOffData?.status === "Rejected" ? (
                                                <Link className="Reject-singlebtn rejected disable-cursor" >
                                                    Rejected <img src={crssrImage} alt="Edit Icon" />
                                                </Link>
                                            ) : (
                                                <Link
                                                    className="Reject-singlebtn"
                                                    onClick={handleReject}
                                                    disabled={isSubmitLoading}
                                                >
                                                    Reject <img src={crssrImage} alt="Edit Icon" />
                                                </Link>
                                            )}
                                            <Modal
                                                className="delete-modal"
                                                isOpen={isRejectModalOpen}
                                                onRequestClose={
                                                    !isSubmitLoading ? handleCancelReject : undefined
                                                }
                                                contentLabel="Confirm Reject"
                                                style={{
                                                    content: {
                                                        height: "41%",
                                                        width: "30%",
                                                        position: "fixed",
                                                        top: "50%",
                                                        left: "50%",
                                                        parent: document.querySelector(
                                                            ".admin-outer.time.tracker"
                                                        ),
                                                    },
                                                }}
                                            >
                                                <div className="delete-modal-content">
                                                    <h2>Confirm Reject</h2>
                                                    <p>
                                                        Are you sure you want to Reject this Time Off
                                                        Request?
                                                    </p>
                                                    {isSubmitLoading ? (
                                                        <div className="delete-modal-buttons">
                                                            <div
                                                                style={{
                                                                    width: "100px",
                                                                    height: "40px",
                                                                    backgroundColor: "#e5e7eb",
                                                                    borderRadius: "6px",
                                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                                    marginRight: "10px",
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: "80px",
                                                                    height: "40px",
                                                                    backgroundColor: "#e5e7eb",
                                                                    borderRadius: "6px",
                                                                    animation: "pulse 1.5s ease-in-out infinite",
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="delete-modal-buttons">
                                                            <button
                                                                className="buttons-rejected buttons-rejected-new"
                                                                onClick={handleConfirmReject}
                                                                disabled={isSubmitLoading}
                                                            >
                                                                Reject
                                                            </button>
                                                            <button
                                                                onClick={handleCancelReject}
                                                                disabled={isSubmitLoading}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Modal>
                                        </>
                                    )
                                )}
                                {!isRefetching && (isAdmin || (isFutureDate && timeOffData?.status !== 'Cancelled')) ? (
                                    <>
                                        {timeOffData?.status === "Cancelled" ?
                                            (
                                                <Link className="cancel-singlebtn cancelled disable-cursor" >
                                                    Cancelled <img src={cancelImage} alt="Edit Icon" />
                                                </Link>
                                            ) :
                                            (
                                                <Link
                                                    className="cancel-singlebtn"
                                                    onClick={handleCancel}
                                                    disabled={isSubmitLoading}
                                                >
                                                    Cancel <img src={cancelImage} alt="Edit Icon" />
                                                </Link>
                                            )}
                                        <Modal
                                            className="delete-modal"
                                            isOpen={isCancelModalOpen}
                                            onRequestClose={
                                                !isSubmitLoading ? handleCancelCancel : undefined
                                            }
                                            contentLabel="Confirm Cancel"
                                            style={{
                                                content: {
                                                    height: "41%",
                                                    width: "30%",
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    parent: document.querySelector(
                                                        ".admin-outer.time.tracker"
                                                    ),
                                                },
                                            }}
                                        >
                                            <div className="delete-modal-content">
                                                <h2>Confirm Cancel</h2>
                                                <p>
                                                    Are you sure you want to Cancel this Time Off
                                                    Request?
                                                </p>
                                                {isSubmitLoading ? (
                                                    <div className="delete-modal-buttons">
                                                        <div
                                                            style={{
                                                                width: "100px",
                                                                height: "40px",
                                                                backgroundColor: "#e5e7eb",
                                                                borderRadius: "6px",
                                                                animation: "pulse 1.5s ease-in-out infinite",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                width: "80px",
                                                                height: "40px",
                                                                backgroundColor: "#e5e7eb",
                                                                borderRadius: "6px",
                                                                animation: "pulse 1.5s ease-in-out infinite",
                                                            }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="delete-modal-buttons">
                                                        <button
                                                            className="modal-btn modal-btn-calendar cancel-border"
                                                            onClick={handleConfirmCancel}
                                                            disabled={isSubmitLoading}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            onClick={handleCancelCancel}
                                                            disabled={isSubmitLoading}
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </Modal>

                                    </>
                                ) : null}
                                {/* {user &&
                            !(user.userType === SUPER_ADMIN ||
                                user.userType === ADMIN ||
                                user.userType === TEAM_MANAGER) && ( */}
                                {user && !isAdmin && (
                                    <Link
                                        className=
                                        {`${timeOffData?.status === "Approved"
                                            ? "Approve-singlebtn approved disable-cursor"
                                            : timeOffData?.status === "Rejected"
                                                ? "Reject-singlebtn rejected disable-cursor"
                                                : timeOffData?.status === "Cancelled"
                                                    ? "cancel-singlebtn cancelled disable-cursor"
                                                    : "Reject-singlebtn disable-cursor"
                                            }`}
                                    >
                                        {timeOffData?.status === "Approved" && (
                                            <>
                                                Approved <img src={tikgImage} alt="Approved Icon" />
                                            </>
                                        )}
                                        {(timeOffData?.status === "Rejected") && (
                                            <>
                                                {timeOffData?.status} <img src={crssrImage} alt="Rejected Icon" />
                                            </>
                                        )}
                                        {(timeOffData?.status === "Cancelled") && (
                                            <>
                                                {timeOffData?.status} <img src={cancelImage} alt="Cancelled Icon" />
                                            </>
                                        )}
                                        {!(timeOffData?.status === "Approved" || timeOffData?.status === "Rejected" || timeOffData?.status === "Cancelled") && (
                                            <>
                                                {timeOffData?.status || "Pending"} <img src={crssrImage} alt="Pending Icon" />
                                            </>
                                        )}
                                    </Link>
                                )}
                            </>
                        </div>
                    </div>
                    {(user?.userType === SUPER_ADMIN || user?.userType === ADMIN) && timeOffData?.tor_verified_by && (
                        <div className="single-invo-sattus">
                            <div className="invo-main-status-head">Reviewed By</div>
                            <div className="company-detail">
                                <div className="companynae-sig">
                                    {timeOffData.tor_verified_by?.first_name ? (
                                        <>
                                            {timeOffData.tor_verified_by.first_name}{' '}
                                            {timeOffData.tor_verified_by.middle_name && timeOffData.tor_verified_by.middle_name !== 'null' ? timeOffData.tor_verified_by.middle_name + ' ' : ''}
                                            {timeOffData.tor_verified_by.last_name}{' '}
                                        </>
                                    ) : (
                                        <>
                                            {timeOffData.tor_verified_by?.company_first_name
                                                ? `${timeOffData.tor_verified_by.company_first_name} ${timeOffData.tor_verified_by.company_last_name ? timeOffData.tor_verified_by.company_last_name : ''}`
                                                : `${timeOffData.tor_verified_by.company_name || ''}(Company)`}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* Pulse animation style */}
            <style>{`
            @keyframes pulse {
                0%, 100% {
                    opacity: 1;
                }
                50% {
                    opacity: 0.5;
                }
            }
        `}</style>
        </>
    );
};

export default ManageTimeOff;